// eslint-disable-next-line import/no-unresolved
import ajax from '@/api/ajax'
import { onlineServiceOrgUrl, onlineServiceUrl } from './config'
import global from '../../util/globalVar'
import { getCookie } from '../../util/util'

// 获取在线客服重定向URL
const getOnlineLinkFromRequest = (region, lang) => {
	const params = {
		orgUrl: onlineServiceOrgUrl[region][lang] || '',
		channelId: '659',
		clientType: '1',
		orgName: 'sy'
	}
	return ajax.getOnlineServiceUrl({
		params
	}).then((res => {
		const result = res && res.data
		let url = ''
		if (result.code === 0) {
			url = result.result
			sessionStorage.setItem('serviceLink', url)
			return url
		}
		return onlineServiceUrl[region][lang] || ''
	})).catch(() => {
		const url = onlineServiceUrl[region][lang]
		return url
	})
}

const getOnlineService = () => {
	const { region, lang } = global
	if (region === 'cn' && lang === 'sc' && !!getCookie('loginUser')) {
		// 缓存中有的话则从缓存中获取
		const sessionLink = sessionStorage.getItem('serviceLink')
		if (sessionLink) return sessionLink
		return getOnlineLinkFromRequest(region, lang)
	}
	// 暂且出内地中文外掐地方从配置文件中获取
	return onlineServiceUrl[region][lang]
}

export default getOnlineService



// WEBPACK FOOTER //
// ./src/mixins/onlineService/index.js